import { render, staticRenderFns } from "./SearchStore.vue?vue&type=template&id=bb9c841e"
import script from "./SearchStore.vue?vue&type=script&lang=js"
export * from "./SearchStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports